import { useLingui } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";

import { Button } from "@/shared/ui/button";

// Разборов ещё нет: задачи собираются из ошибок разбора, поэтому зовём разобрать матч
// и показываем, какие задачи будут.
export const NoAnalyses = () => {
  const { t } = useLingui();
  const examples = [
    {
      kind: t`Buying`,
      title: t`What will you buy now?`,
      text: t`The moment you bought the wrong thing or sat on souls, and what strong players on your hero take there.`,
    },
    {
      kind: t`Defense`,
      title: t`What will you buy for defense?`,
      text: t`Most of the damage on you was of one type and you had no defense: what strong players buy against it.`,
    },
    {
      kind: t`Deaths`,
      title: t`What saves you from him?`,
      text: t`Who killed you the most and with what, and the question: what strong players on your hero take against him.`,
    },
  ];
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-1.5">
        <h1 className="font-display text-[32px] leading-tight">{t`Training`}</h1>
        <p className="max-w-[640px] text-base text-muted">
          {t`Tasks are built from moments of your own matches, so an analysis comes first. Analyze a match and its mistakes become your first tasks.`}
        </p>
      </div>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(260px,1fr))] gap-3">
        {examples.map((example) => (
          <article
            key={example.title}
            className="flex flex-col gap-1.5 rounded-xl border border-border bg-surface px-4.5 py-4"
          >
            <span className="text-xs tracking-[0.06em] text-accent uppercase">{example.kind}</span>
            <h2 className="text-[17px] font-semibold">{example.title}</h2>
            <p className="text-sm text-muted">{example.text}</p>
          </article>
        ))}
      </div>
      <Button asChild size="lg" className="min-h-12 self-start px-6 no-underline">
        <Link to="/">{t`Pick a match to analyze`}</Link>
      </Button>
    </div>
  );
};
